import { Component, OnInit } from '@angular/core';
import {AdminCompetitionService} from '../../../../services/admin/admin-competition.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {CompetitionModel} from '../../../../models/competition/competition.model';
import {Enums} from '../../../../models/extensions/enums';
import {ModalService} from '../../../../shared/modals/modal/modal.service';
import {ErrorModel} from '../../../../models/shared/error.model';
import {CountryModel} from '../../../../models/localization-and-pricing/country.model';

@Component({
  selector: 'app-admin-competitions-settings',
  templateUrl: './admin-competitions-settings.component.html',
  styleUrls: ['./admin-competitions-settings.component.css']
})
export class AdminCompetitionsSettingsComponent implements OnInit {

  competition: CompetitionModel;
  competitionTypesDropdownList = Enums.CompetitionTypes.dropdownList();
  allCountries = CountryModel.privateList();

  constructor(private route: ActivatedRoute,
              private router: Router,
              private modalSv: ModalService,
              private competitionSv: AdminCompetitionService) { }

  ngOnInit() {
    this.route.parent.params.subscribe((params: Params) => {
      this.fetchCompetition(params.competitionId);
    });
  }

  fetchCompetition(competitionId: string) {

    if (competitionId) {
      this.competitionSv.fetchCompetitionById(competitionId).subscribe((competition) => {
        this.competition = competition;
      });
    }

  }

  duplicateCompetition() {

    this.modalSv.showChoiceModal(
      'Duplicate competition',
      'This creates a private copy of the competition with its goals and awards. Participants and activity are not copied.',
      'Duplicate',
      'Cancel'
    ).subscribe((accepted) => {

      if (!accepted) {
        return;
      }

      this.competitionSv.duplicateCompetition(this.competition._id).subscribe((copy) => {

        this.modalSv.showAlertModal('Success', 'Competition was successfully duplicated. The copy is not public yet.', 'Open copy').subscribe(() => {
          this.router.navigate(['admin', 'competitions', copy._id, 'detail', 'settings']);
        });

      }, (err: ErrorModel) => {

        this.modalSv.showTranslatedErrorModal(err);

      });

    });

  }

  saveCompetition() {

    if (this.competition.isConsumer() && this.competition.countries.length === 0) {
      this.modalSv.showAlertModal('Countries required', 'Select at least one country for a consumer competition.', 'Ok');
      return;
    }

    this.competition.startAt.setHours(0, 0, 0, 0);
    this.competition.endAt.setHours(23, 59, 59, 999);

    // Optional, clearing the date removes the deadline
    if (this.competition.redeemEndAt) {
      this.competition.redeemEndAt.setHours(23, 59, 59, 999);
    } else {
      this.competition.redeemEndAt = null;
    }

    this.competitionSv.updateCompetition(this.competition).subscribe((comp) => {

      this.competition = comp;
      this.modalSv.showAlertModal('Success', 'Competition was successfully saved', 'Ok');

    }, (err: ErrorModel) => {

      this.modalSv.showTranslatedErrorModal(err);

    });

  }

}
